import { WeatherSettingsChangeSource } from '@fe/weather';
import { LightingColorOptions, LightningSymbolOptions } from '../settings-options';
import { useDropdownSetting } from './hooks/useSetting';
import { DropDownList } from '@progress/kendo-react-dropdowns';

export default function LightningSettings() {
    const symbol = useDropdownSetting(LightningSymbolOptions, 'lightning', 'symbol', WeatherSettingsChangeSource.lightning);
    const color = useDropdownSetting(LightingColorOptions, 'lightning', 'color', WeatherSettingsChangeSource.lightning);

    return (
        <div className="d-flex gap-2 flex-column">
            <div>
                <div>Symbol:</div>
                <DropDownList {...symbol} />
            </div>

            <div>
                <div>Color:</div>
                <DropDownList {...color} />
            </div>
        </div>
    );
}
